import {
  B_16,
  BANNER_DEFAULTS,
  hideB16Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B16_PLASMIC_PROPS = {
  b16Eyebrow: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].eyebrow,
    description: "Eyebrow text (B16 only)",
    hidden: hideB16Props,
  },
  b16Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].heading,
    description: "Main heading (B16 only)",
    hidden: hideB16Props,
  },
  b16Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].description,
    description: "Description text (B16 only)",
    hidden: hideB16Props,
  },
  b16PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].primaryButtonText,
    description: "Primary CTA button text (B16 only)",
    hidden: hideB16Props,
  },
  b16PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].primaryButtonUrl,
    description: "Primary CTA button URL (B16 only)",
    hidden: hideB16Props,
  },
  b16Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_16].image,
    description: "Main image (B16 only)",
    hidden: hideB16Props,
  },
  b16ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_16].imageAlt,
    description: "Image alt text (B16 only)",
    hidden: hideB16Props,
  },
};
